module.exports = {
  id: 18,
  name: 'Tiger Pounces',
  categories: ['cardio', 'legs', 'coordination'],
  sports: [
    'ballet',
    'baseball',
    'basketball',
    'dance',
    'football',
    'martial-arts',
    'gymnastics',
    'running-technique',
    'soccer',
    'taekwondo',
    'tennis',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Coordination',
  points: 13,
  instructions:
    'Tiger Pounces make you pounce like a tiger! Stand with your feet apart, crouch down like a tiger, then jump forward and land softly like a tiger pouncing!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to pounce like a tiger? Let us build incredible coordination and power!',
    },
    {
      time: 3,
      text: 'Stand with feet shoulder-width apart, ready to pounce!',
    },
    {
      time: 6,
      text: 'Keep your core engaged and get ready to be fierce!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Bend your knees and crouch down like a tiger!',
    },
    // SET 1 - 8 tiger pounces
    {
      time: 12,
      text: 'Perfect tiger position! Feet shoulder-width apart, ready to pounce!',
    },
    {
      time: 15,
      text: 'Number 1! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 18,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 21,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 24,
      text: 'Number 2! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 27,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 30,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 33,
      text: 'Number 3! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 36,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 39,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 42,
      text: 'Number 4! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 45,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 48,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 51,
      text: 'Number 5! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 54,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 57,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 60,
      text: 'Number 6! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 63,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 66,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 69,
      text: 'Number 7! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 72,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 75,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 78,
      text: 'Number 8! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 81,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 84,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 87,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 90,
      text: 'Take a deep breath in and out, you are building incredible coordination!',
    },
    {
      time: 93,
      text: 'Shake out your legs and feet, get ready for round two!',
    },
    {
      time: 96,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 99,
      text: 'Remember to crouch down like a tiger and pounce forward!',
    },
    {
      time: 102,
      text: '3, 2, 1, START! Bend your knees and crouch down like a tiger!',
    },
    // SET 2 - 8 tiger pounces
    {
      time: 105,
      text: 'Perfect tiger position! Feet shoulder-width apart, ready to pounce!',
    },
    {
      time: 108,
      text: 'Number 1! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 111,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 114,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 117,
      text: 'Number 2! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 120,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 123,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 126,
      text: 'Number 3! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 129,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 132,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 135,
      text: 'Number 4! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 138,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 141,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 144,
      text: 'Number 5! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 147,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 150,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 153,
      text: 'Number 6! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 156,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 159,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 162,
      text: 'Number 7! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 165,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 168,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 171,
      text: 'Number 8! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 174,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 177,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 180,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 183,
      text: 'Take a deep breath in and out, you are building incredible coordination!',
    },
    {
      time: 186,
      text: 'Shake out your legs and feet, get ready for round three!',
    },
    {
      time: 189,
      text: 'You are doing amazing! Ready for round three? Let us keep going!',
    },
    {
      time: 192,
      text: 'Remember to crouch down like a tiger and pounce forward!',
    },
    {
      time: 195,
      text: '3, 2, 1, START! Bend your knees and crouch down like a tiger!',
    },
    // SET 3 - 8 tiger pounces
    {
      time: 198,
      text: 'Perfect tiger position! Feet shoulder-width apart, ready to pounce!',
    },
    {
      time: 201,
      text: 'Number 1! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 204,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 207,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 210,
      text: 'Number 2! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 213,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 216,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 219,
      text: 'Number 3! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 222,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 225,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 228,
      text: 'Number 4! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 231,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 234,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 237,
      text: 'Number 5! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 240,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 243,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 246,
      text: 'Number 6! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 249,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 252,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 255,
      text: 'Number 7! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 258,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 261,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 264,
      text: 'Number 8! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 267,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 270,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 273,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 3 - 20 seconds
    {
      time: 276,
      text: 'Take a deep breath in and out, you are building incredible coordination!',
    },
    {
      time: 279,
      text: 'Shake out your legs and feet, get ready for the final round!',
    },
    {
      time: 282,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 285,
      text: 'Remember to crouch down like a tiger and pounce forward!',
    },
    {
      time: 288,
      text: '3, 2, 1, START! Bend your knees and crouch down like a tiger!',
    },
    // SET 4 - 8 tiger pounces
    {
      time: 291,
      text: 'Perfect tiger position! Feet shoulder-width apart, ready to pounce!',
    },
    {
      time: 294,
      text: 'Number 1! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 297,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 300,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 303,
      text: 'Number 2! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 306,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 309,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 312,
      text: 'Number 3! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 315,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 318,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 321,
      text: 'Number 4! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 324,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 327,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 330,
      text: 'Number 5! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 333,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 336,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 339,
      text: 'Number 6! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 342,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 345,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 348,
      text: 'Number 7! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 351,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 354,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 357,
      text: 'Number 8! Bend your knees and crouch down like a tiger!',
    },
    {
      time: 360,
      text: 'Jump forward and land softly like a tiger pouncing!',
    },
    {
      time: 363,
      text: 'Use your arms for balance and keep your core engaged!',
    },
    {
      time: 366,
      text: 'Incredible work! You just completed all four sets!',
    },
    // COMPLETION
    {
      time: 369,
      text: 'Amazing work! You did 32 tiger pounces and built incredible coordination!',
    },
    {
      time: 372,
      text: 'You are getting super coordinated and powerful! You are a tiger master!',
    },
    {
      time: 375,
      text: 'Great job, coordination champion! You are building incredible skills!',
    },
  ],
};
